export default class Block12 {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.query = query;
        this.el = el;

        const controls = this.el.querySelectorAll(`${this.query}__tabs--nav`);
        if (!controls || !controls.length) return;

        this.controls = [...controls];

        const panels = this.el.querySelectorAll(`${this.query}__tabs--pane`);
        if (!panels || !panels.length) return;

        this.panels = [...panels];

        const dropdown = this.el.querySelector(`${this.query}--dropdown`);
        if (!dropdown) return;

        this.dropdown = dropdown;

        const text = this.dropdown.querySelector(`${this.query}--dropdown-text`);
        if (!text) return;

        this.text = text;

        this.init();
    }

    init () {
        this.controls[0].classList.add('active');
        this.panels[0].classList.add('active');

        this.setupTabs();
        this.setupDropdown();
    }

    setupTabs () {
        this.text.textContent = this.controls[0].textContent;

        this.controls.forEach((item) => {
            const { control } = item.dataset;

            const panel = this.panels.filter((i) => i.dataset.pane === control)[0];

            item.addEventListener('click', (event) => {
                event.stopPropagation();

                this.controls.forEach((i) => i.classList.remove('active'));
                this.panels.forEach((i) => i.classList.remove('active'));

                if (panel) {
                    const current = this.controls.filter((i) => i.dataset.control === control);
 
                    [...current].forEach((i) => i.classList.add('active'));

                    this.text.textContent = current[0].textContent;

                    panel.classList.add('active');
                }
            });
        });
    }

    setupDropdown () {
        const trigger = this.dropdown.querySelector(`${this.query}--dropdown-trigger`);
        const list = this.dropdown.querySelector(`${this.query}--dropdown-list`);

        const calulate = () => {
            list.style.maxHeight = 'none';

            const height = list.scrollHeight;

            list.style.maxHeight = 0;

            return height;
        }

        const toggle = (state) => {
            if (!state) {
                this.dropdown.classList.remove('collapsed');

                setTimeout(() => list.style.maxHeight = 0, 100);
            } else {
                const height = calulate();

                this.dropdown.classList.add('collapsed');

                setTimeout(() => list.style.maxHeight = `${height}px`, 100);
            }
        }

        window.addEventListener('click', (event) => {
            event.stopPropagation();

            toggle(false);
        });

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();

            toggle(!this.dropdown.classList.contains('collapsed'));
        });

        Array.from(list.querySelectorAll(`${this.query}__tabs--nav`)).forEach((item) => {
            item.addEventListener('click', (event) => {
                event.stopPropagation();
    
                setTimeout(() => toggle(false), 100);
            });
        });
    }
}
